import s from './ReturnArtifacts.module.css';
import type { ReturnArtifact } from './types';
import { Loader } from '@repo/ui/Loader';
import { Text } from '../Language/Language';
import { Flex } from '@repo/ui/Flex';
import type { ReactNode } from 'react';

const Wrapper = ({ children }: { children: ReactNode }) => (
  <Flex
    className={s.qrCodeWrapper}
    direction="column"
    gap="g-24"
    alignItems="center"
    justifyContent="center"
  >
    {children}
  </Flex>
);

export const ReturnQRCode = ({
  qrCode,
  isPolling,
}: {
  qrCode?: ReturnArtifact;
  isPolling?: boolean;
}) => {
  if (isPolling) {
    return (
      <Wrapper>
        <Loader />
        <span className={s.qrCodeLoaderText}>
          <Text langKey="Global.confirmation.printerless.loading" />
        </span>
      </Wrapper>
    );
  }

  if (!qrCode?.url) return null;

  return (
    <Wrapper>
      <img className={s.qrCode} src={qrCode.url} alt="QR Code" />
    </Wrapper>
  );
};
